module.exports = __webpack_public_path__ + "img/48.8396f65c.jpg";